module.exports = __webpack_public_path__ + "img/logo-non-text.08297a9.svg";